import { takeEvery, put, call } from "redux-saga/effects"

import { MY_TEAM_ADD_USER, MY_TEAM_ALL_ROLES } from "./actionTypes"

import { addUserFailed, getAllRolesSuccessful, addUserSuccessful } from "./actions"

import { getALLRolesGet, addNewUserPost } from "../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

// get candidate list
function* getAllRolesF() {
  try {
    var url = constClass.REST_API_MYTEAM_ALL_ROLES;
    var responsJSON = yield call(getALLRolesGet, url);
    yield put(getAllRolesSuccessful(responsJSON))
  }
  catch (error) {
    console.error(error)
  }
}

// get candidate list
function* addUser({ payload: { newUserMyTeam } }) {
  try {
    var url = constClass.REST_API_MYTEAM_ADD_NEW_USER_POST;
    var jsonResponse = yield call(addNewUserPost, url, newUserMyTeam);
    yield put(addUserSuccessful(jsonResponse.message));
   
  }
  catch (error) {
    yield put(addUserFailed(error))
  }
}

function* getAddNewUserSaga() {
  yield takeEvery(MY_TEAM_ADD_USER, addUser);
  yield takeEvery(MY_TEAM_ALL_ROLES, getAllRolesF);
}

export default getAddNewUserSaga